<template>
  <div class="ReleaseNotes">
    <PlainNavBar />
    <ParentPage
      v-if="menu.length"
      class="ReleaseNotes"
      :menu="menu"
      :root-route-name="rootRouteName"
    />
    <Overlay />
  </div>
</template>

<script>
import ParentPage from '@/components/manual/ParentPage.vue'
import PlainNavBar from '@/components/navbar/PlainNavBar.vue'
import Overlay from '@/components/common/Overlay'

export default {
  name: 'ReleaseNotes',
  components: {
    ParentPage,
    PlainNavBar,
    Overlay,
  },
  data() {
    return {
      releaseNotes: [],
      rootRouteName: 'ReleaseNotes',
    }
  },
  computed: {
    menu() {
      const releaseNotesList = []
      this.releaseNotes?.map((releaseNote) => {
        const data = releaseNote.data['nl-NL']
        const item = {
          type: 'link',
          label: data.title,
          to: {
            name: 'ReleaseNotePage',
            params: { uuid: releaseNote.uuid },
          },
        }

          releaseNotesList.push(item)
      })
      return releaseNotesList
    },
  },
  async created() {
    try {
      const token = await this.$auth.getTokenSilently()
      const response = await fetch('/api/get-release-notes', {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      if (response.status === 200) {
        this.releaseNotes = await response.json()
      }
      if (response.status === 404) {
        this.releaseNotes = 'Handleidingen niet gevonden'
      }
    } catch (error) {
      console.log(error)
    }
  },
}
</script>

<style>
.ReleaseNotes {
  height: 100%;
}
</style>
